import { render } from "./preguntar.vue?vue&type=template&id=9756a244&scoped=true"
import script from "./preguntar.vue?vue&type=script&lang=js"
export * from "./preguntar.vue?vue&type=script&lang=js"

import "./preguntar.vue?vue&type=style&index=0&id=9756a244&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9756a244"]])

export default __exports__